import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import useStatusThunk from "../../../hook/useStatusThunk";
import DisplayError from "../../dumb/DisplayError";
import { preTranslate } from "../../../redux/ducks/task";
import NumInput from "../../dumb/NumInput";

const PreTranslateTask = props => {
    const [show, hide, renderModal] = useModal();
    const [d_preTranslate, status, error, event] = useStatusThunk(preTranslate);

    const [memoryMatchThreshold, setMemoryMatchThreshold] = useState();

    event.onSuccess = () => {
        hide();
        setMemoryMatchThreshold();
    }
    

    const preTran = () => {
        for (let i = 0; i < props.taskIDs.length; i++) 
        {
        d_preTranslate({ taskIDs: props.taskIDs[i], memoryMatchThreshold })
        }
    }

    return (
        <React.Fragment>
            <button className={"button button--warm " + props.className} onClick={show}>Pre Translate</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="label">Minimum memory threshold</div>
                        <NumInput set={setMemoryMatchThreshold} v={memoryMatchThreshold} />
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--warm" onClick={() => preTran()}>Pre Translate</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default PreTranslateTask;